import { ColumnDef } from '@tanstack/react-table';
import { ScheduledStockBalanceReport } from 'contracts/scheduledRepports';
import { DataTableUtils, Formatter } from 'utils';
import { downloadReport } from '../utils';

type GetColumns = () => ColumnDef<ScheduledStockBalanceReport>[];

const dt = new DataTableUtils<ScheduledStockBalanceReport>();

export const getColumns: GetColumns = () => {
  return [
    dt.buildColumn({
      accessorKey: 'created_at',
      title: 'Requisitado em',
      content: (row) => Formatter.dateTime(row.created_at),
    }),
    dt.buildColumn({
      accessorKey: 'finished_at',
      title: 'Finalizado em',
      content: (row) =>
        row.finished_at ? Formatter.dateTime(row.finished_at) : '---',
    }),
    dt.buildColumn({
      accessorKey: 'expiration_date_start',
      title: 'Vencimento',
      content: (row) => {
        const { expiration_date_start, expiration_date_end } = row;

        if (!expiration_date_start) {
          return '---';
        }

        if (expiration_date_start === expiration_date_end) {
          return Formatter.date(expiration_date_start);
        }

        const parts = [Formatter.date(expiration_date_start)];

        if (expiration_date_end) {
          parts.push(Formatter.date(expiration_date_end));
        }

        return parts.join(' - ');
      },
    }),
    dt.buildStatusColumnForScheduledReports({
      onDownloadButtonClick: downloadReport,
    }),
  ];
};
